<template>
  <div class="page">
    <div class="tg fjs-tg" v-if="isSingle">
      <router-link
        class="tg-item tg-single"
        :to="'/contribute/' + id + '/' + type + '/single?group=' + gid"
        ><img :src="bgImg[0]"
      /></router-link>
    </div>
    <div class="tg fjs-tg" v-if="isMulti">
      <router-link
        class="tg-item tg-multi"
        :to="'/contribute/' + id + '/' + type + '/multi?group=' + gid"
        ><img :src="bgImg[1]"
      /></router-link>
    </div>
    <div class="tg fjs-tg" v-if="isGroup">
      <router-link
        class="tg-item tg-multi"
        :to="'/contribute/' + id + '/' + type + '/group?group=' + gid"
        ><img :src="bgImg[1]"
      /></router-link>
    </div>
    <div class="tg fjs-tg" v-if="isVideo">
      <router-link
        class="tg-item tg-video"
        :to="'/contribute/' + id + '/' + type + '/video?group=' + gid"
        ><img :src="bgImg[2]"
      /></router-link>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import Head from "@/layouts/Head.vue";

export default {
  name: "Contribute",
  data() {
    return {
      bgImg: [
        require("@/static/images/1224/tg-1.png"),
        require("@/static/images/1224/tg-2.png"),
        require("@/static/images/1224/tg-3.png")
      ],
      type: this.$route.params.type,
      id: this.$route.params.id,
      gid: this.$route.query.group,
      isSingle: false,
      isMulti: false,
      isGroup: false,
      isVideo: false
      // 缓存 matchList 初始化列表，用 list 筛选赋值 matchList
    };
  },
  mounted() {
    console.log(this.type);
    this.isSingle = this.type.indexOf("single") > -1;
    this.isMulti = this.type.indexOf("multi") > -1;
    this.isGroup = this.type.indexOf("group") > -1;
    this.isVideo = this.type.indexOf("video") > -1;
  }
};
</script>

<style lang="scss">
.fjs-tglist {
  justify-content: space-around;
}
</style>
